/** Design-token bridge for the shared outline row; mounted once per document by the renderer. */
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const outlineRowStyleId = 'outline-row-theme';

export const outlineRowBridgeStyles = {
  'outline-row': {
    '--local-outline-row-font': tokens.font.family.body,
    '--local-outline-row-title-text': tokens.color.text.primary,
    '--local-outline-row-line-title-text': tokens.color.text.primary,
    '--local-outline-row-mandatory-text': tokens.color.text.errorPrimary,
    '--local-outline-row-summary-text': tokens.color.text.tertiary,
    '--local-outline-row-chevron-color': tokens.color.text.quaternary,
    '--local-outline-row-nested-connector': tokens.color.border.secondary,
    '--local-outline-row-glyph-slot': '20px',
    '--local-outline-row-glyph-icon-size': tokens.font.size.textXs,
    '--local-outline-row-glyph-radius': tokens.radius.sm,
    '--local-outline-row-line-bg': tokens.color.background.secondarySubtle,
    '--local-outline-row-line-glyph-bg': tokens.color.background.brandPrimary,
    '--local-outline-row-line-glyph-icon': tokens.color.foreground.brandPrimary,
    '--local-outline-row-task-glyph-icon': tokens.color.foreground.quaternary,
    '--local-outline-row-glyph-dot-color': tokens.color.border.tertiary,
    '--local-outline-row-property-bg': tokens.color.background.primary,
    '--local-outline-row-property-border': tokens.color.border.secondary,
    '--local-outline-row-property-text': tokens.color.text.secondary,
    '--local-outline-row-warning-bg': tokens.color.background.warningPrimary,
    '--local-outline-row-warning-border': tokens.color.border.secondary,
    '--local-outline-row-warning-text': tokens.color.text.warningPrimary,
    '--local-outline-row-title-size': tokens.font.size.textSm,
    '--local-outline-row-subtask-title-size': tokens.font.size.textSm,
    '--local-outline-row-subtask-title-line-height': tokens.lineHeight.textSm,
    '--local-outline-row-subtask-title-text': tokens.color.text.secondary,
    '--local-outline-row-mandatory-size': tokens.font.size.textLg,
    '--local-outline-row-summary-size': tokens.font.size.textXs,
    '--local-outline-row-title-weight': tokens.font.weight.regular,
    '--local-outline-row-line-title-weight': tokens.font.weight.semibold,
    '--local-outline-row-task-title-weight': tokens.font.weight.medium,
    '--local-outline-row-summary-weight': tokens.font.weight.regular,
    '--local-outline-row-title-line-height': tokens.lineHeight.textSm,
    '--local-outline-row-mandatory-line-height': tokens.lineHeight.textSm,
    '--local-outline-row-summary-line-height': tokens.lineHeight.textXs,
    '--local-outline-row-heading-gap': tokens.spacing.sm,
    '--local-outline-row-actions-gap': tokens.spacing.xs,
    '--local-outline-row-indent-step': tokens.spacing.xs,
    '--local-outline-row-gutter': tokens.spacing.twoXl,
    // Compact fixed slot keeps the checkbox adjacent to the title while retaining a predictable target.
    '--local-outline-row-select': tokens.spacing.twoXl,
    '--local-outline-row-connector-lane': '28px',
    // Caps a property chip so a long schedule can never push the actions off the row.
    // Sized for the compact describeShort() forms (~24 characters); the full summary is the tooltip.
    '--local-outline-row-property-max-width': '180px',
    '--local-outline-row-inline-gap': tokens.spacing.md,
    // Was the grid cell's 20px --local-board-list-planner-inline-padding; the row owns it now, tighter.
    '--local-outline-row-inline-padding': tokens.spacing.lg,
    '--local-outline-row-chevron-transition': '120ms ease',
    '--local-outline-row-chevron-size': tokens.font.size.textXs,
    '--local-outline-row-avatar-size': '20px',
    '--local-outline-row-avatar-font-size': tokens.font.size.textXs,
  },
  // Tooltip card renders through pTooltip appendTo body, so it is styled globally rather than
  // under the row element — its values are scoped to the card's own class instead.
  '.outline-schedule-card': {
    '--local-outline-tooltip-label-text': tokens.color.text.white,
    '--local-outline-tooltip-value-text': tokens.color.text.white,
    // The shared dark tooltip surface has no dedicated muted-on-dark token; the label is the same
    // white held back so the value reads as primary.
    '--local-outline-tooltip-label-opacity': '0.6',
    '--local-outline-tooltip-label-size': tokens.font.size.textSm,
    '--local-outline-tooltip-label-line-height': tokens.lineHeight.textSm,
    '--local-outline-tooltip-value-size': tokens.font.size.textMdBase,
    '--local-outline-tooltip-value-line-height': tokens.lineHeight.textMd,
    '--local-outline-tooltip-gap': tokens.spacing.mdAlt,
    '--local-outline-tooltip-row-gap': tokens.spacing.xxs,
    '--local-outline-tooltip-min-width': '200px',
    '--local-outline-tooltip-max-width': '280px',
  },
};
